import { render, staticRenderFns } from "./goods.vue?vue&type=template&id=01a6687c&scoped=true&"
import script from "./goods.vue?vue&type=script&lang=js&"
export * from "./goods.vue?vue&type=script&lang=js&"
import style0 from "./goods.vue?vue&type=style&index=0&id=01a6687c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a6687c",
  null
  
)

export default component.exports